document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const instaHeading = document.querySelector("#insta-feed h2");
    if (instaHeading) {
      instaHeading.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0326/0684/7115/files/top-Instagram_logo.jpg?v=1788514124" alt="Instagram">';
    }
  }, 1000); // 1秒後に実行
});